// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"884":"admin","966":"login"}[chunkId] + "-legacy." + {"884":"0bc33d23","966":"5eb6d73c"}[chunkId] + ".js";
};